<!-- ══════════════════════════════════════════════════════════════════
     CHAT ÁGATA — Clarity Design System
     Paleta: Principal #1C3762 (navy) | Secundario #47B5AF (teal) |
             Fondos blancos | Bordes #E4E4E4
     Tipografía: Prompt (body)
     ══════════════════════════════════════════════════════════════════ -->
<div class="w-full min-h-screen flex items-center justify-center px-2 sm:px-4 bg-gray-50"
     style="padding: 20px 8px;">

    <div #chatSection
        class="flex h-[540px] md:h-[630px] lg:h-[410px] xl:h-[610px] antialiased w-full max-w-4xl">

        <!-- Tarjeta principal del chat -->
        <div class="flex flex-row h-full w-full overflow-x-hidden rounded-xl sm:rounded-2xl"
             style="border: 1px solid #E4E4E4;
                    box-shadow: 0 4px 24px rgba(28,55,98,0.10), 0 1px 4px rgba(0,0,0,0.06);">

            <!-- ────────────────────────────────────────────────────── -->
            <!--  COLUMNA PRINCIPAL DEL CHAT                           -->
            <!-- ────────────────────────────────────────────────────── -->
            <div class="flex flex-col flex-auto h-full z-30 bg-white">

                <!-- ══════════════════════════════════════════
                     HEADER — Clarity / ÁGATA
                     ══════════════════════════════════════════ -->
                <div class="rounded-t-xl sm:rounded-t-2xl sticky top-0 z-50"
                     style="background: #1C3762;
                            border-bottom: 1px solid rgba(71,181,175,0.35);">
                    <div class="flex items-center gap-2.5 sm:gap-3 p-3 sm:p-4">

                        <!-- Avatar circular — teal con inicial -->
                        <div class="flex items-center justify-center rounded-full flex-shrink-0
                                    h-8 w-8 sm:h-9 sm:w-9"
                             style="background: #47B5AF; min-width: 32px;">
                            <span class="text-white font-bold leading-none
                                         text-[11px] sm:text-xs tracking-tight">CL</span>
                        </div>

                        <!-- Logotipo y subtítulo -->
                        <div class="flex-1 min-w-0">
                            <h4 class="font-bold leading-none uppercase tracking-wider
                                       text-sm sm:text-base xl:text-lg text-white m-0">
                                Clarity
                                <span class="font-normal text-[10px] sm:text-xs tracking-normal normal-case opacity-75 ml-1">
                                    · Asistente IA
                                </span>
                            </h4>
                        </div>

                        <!-- Indicador de estado -->
                        <div class="flex items-center gap-1.5 flex-shrink-0">
                            <span class="rounded-full animate-pulse h-1.5 w-1.5 sm:h-2 sm:w-2"
                                  style="background: #47B5AF;"></span>
                            <span class="hidden sm:inline text-[10px] uppercase tracking-wider"
                                  style="color: rgba(71,181,175,0.75);">EN LÍNEA</span>
                        </div>
                    </div>
                </div>
                <!-- /HEADER -->

                <div class="flex flex-col flex-auto h-0 overflow-y-auto p-1">

                    <!-- ══════════════════════════════════════════
                         ÁREA DE MENSAJES
                         ══════════════════════════════════════════ -->
                    <div class="flex flex-col h-full overflow-y-auto bg-white chat-messages-scroll" #chatbox>
                        <div class="flex flex-col h-full p-1.5 sm:p-2">

                            <ng-container *ngFor="let msg of messages">
                                <div class="grid grid-cols-12 gap-y-1 sm:gap-y-2">

                                    <!-- ─────────────────────────────────
                                         BURBUJA: USUARIO
                                         ───────────────────────────────── -->
                                    <div *ngIf="msg.sender === 'user'"
                                        class="col-start-3 sm:col-start-4 md:col-start-5 col-end-13
                                               p-1.5 sm:p-2">
                                        <div class="flex items-end justify-end">
                                            <div class="relative text-sm sm:text-base py-2 px-3 sm:px-4
                                                        break-words overflow-wrap-anywhere"
                                                 style="background: #1C3762;
                                                        border-radius: 12px 12px 2px 12px;
                                                        max-width: 100%;">

                                                <!-- Archivo adjunto: advertencia -->
                                                <div *ngIf="msg.file"
                                                    class="mb-2 rounded p-2 flex items-center space-x-2"
                                                    style="background: rgba(255,151,53,0.15);
                                                           border: 1px solid rgba(255,151,53,0.4);">
                                                    <div class="flex items-center justify-center h-7 w-7
                                                                rounded flex-shrink-0"
                                                         style="background: rgba(255,151,53,0.25);">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="h-4 w-4" fill="none"
                                                            viewBox="0 0 24 24" stroke="#FF9735">
                                                            <path stroke-linecap="round"
                                                                stroke-linejoin="round" stroke-width="2"
                                                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                                        </svg>
                                                    </div>
                                                    <div class="flex-1 min-w-0">
                                                        <p class="text-xs font-semibold truncate"
                                                           style="color: #FF9735;">⚠️ Archivo no procesado</p>
                                                        <p class="text-[10px] truncate"
                                                           style="color: rgba(255,151,53,0.8);">
                                                            {{ msg.file.name.length > 20
                                                                ? (msg.file.name | slice:0:20) + '…'
                                                                : msg.file.name }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- Texto del mensaje -->
                                                <span class="text-white font-medium"
                                                      [innerHTML]="msg.message"></span>

                                                <!-- Timestamp -->
                                                <div *ngIf="msg.timestamp"
                                                    class="text-right mt-1 text-[10px]"
                                                    style="color: rgba(255,255,255,0.55);">
                                                    {{ msg.timestamp | date:'shortTime' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- ─────────────────────────────────
                                         BURBUJA: BOT
                                         ───────────────────────────────── -->
                                    <div *ngIf="msg.sender === 'bot'"
                                        class="col-start-1 col-end-12 md:col-end-11 p-1.5 sm:p-2">
                                        <div class="flex flex-row items-start gap-2">

                                            <!-- Avatar ÁG -->
                                            <div class="flex items-center justify-center rounded-full
                                                        flex-shrink-0
                                                        h-7 w-7 sm:h-8 sm:w-8 lg:h-9 lg:w-9"
                                                 style="background: #47B5AF; min-width: 28px;">
                                                <span class="text-white font-bold leading-none
                                                             tracking-tight
                                                             text-[8px] sm:text-[10px]">ÁG</span>
                                            </div>

                                            <!-- Burbuja bot: fondo gris claro + borde izquierdo teal -->
                                            <div class="relative text-sm sm:text-base py-2 px-3 sm:px-4
                                                        break-words overflow-hidden max-w-full"
                                                 style="background: #F4F7FB;
                                                        border-radius: 12px 12px 12px 2px;
                                                        border-left: 3px solid #47B5AF;">

                                                <span style="color: #1C3762;"
                                                      [innerHTML]="msg.message"></span>

                                                <!-- Reproductor de audio -->
                                                <div *ngIf="msg.audio && msg.audioUrl"
                                                    class="mt-2 p-2 rounded-lg"
                                                    style="background: rgba(71,181,175,0.08);
                                                           border-top: 1px solid rgba(71,181,175,0.2);">
                                                    <audio controls class="flex-1 h-8"
                                                           style="max-width: 250px;">
                                                        <source [src]="msg.audioUrl" type="audio/mpeg">
                                                        <source [src]="msg.audioUrl" type="audio/wav">
                                                        <source [src]="msg.audioUrl" type="audio/ogg">
                                                        Tu navegador no soporta audio.
                                                    </audio>
                                                </div>

                                                <!-- Timestamp -->
                                                <div *ngIf="msg.timestamp"
                                                    class="mt-1 text-[10px]"
                                                    style="color: rgba(28,55,98,0.38);">
                                                    {{ msg.timestamp | date:'shortTime' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- ─────────────────────────────────
                                 INDICADOR "PENSANDO"
                                 ───────────────────────────────── -->
                            <div *ngIf="isThinking" class="grid grid-cols-12 gap-y-1 sm:gap-y-2">
                                <div class="col-start-1 col-end-8 p-1.5 sm:p-2">
                                    <div class="flex flex-row items-start gap-2">
                                        <div class="flex items-center justify-center rounded-full
                                                    flex-shrink-0
                                                    h-7 w-7 sm:h-8 sm:w-8 lg:h-9 lg:w-9"
                                             style="background: #47B5AF; min-width: 28px;">
                                            <span class="text-white font-bold leading-none
                                                         tracking-tight
                                                         text-[8px] sm:text-[10px]">ÁG</span>
                                        </div>
                                        <div class="relative py-3 px-4 flex items-center"
                                             style="background: #F4F7FB;
                                                    border-radius: 12px 12px 12px 2px;
                                                    border-left: 3px solid #47B5AF;
                                                    min-height: 36px;">
                                            <div class="loader"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /ÁREA DE MENSAJES -->

                    <!-- ══════════════════════════════════════════
                         ÁREA DE INPUT
                         ══════════════════════════════════════════ -->
                    <div class="z-50 sticky bottom-0 rounded-b-xl sm:rounded-b-2xl p-2 sm:p-3
                                overflow-hidden bg-white"
                         style="border-top: 1px solid #E4E4E4;">

                        <!-- Advertencia archivo seleccionado -->
                        <div *ngIf="selectedFile"
                            class="rounded-lg p-2 sm:p-2.5 mb-2 flex items-center space-x-2 sm:space-x-3"
                            style="background: rgba(255,151,53,0.07);
                                   border: 1px solid rgba(255,151,53,0.35);">
                            <div class="flex items-center justify-center h-8 w-8 rounded flex-shrink-0"
                                 style="background: rgba(255,151,53,0.18);">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                    viewBox="0 0 24 24" stroke="#FF9735">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                            <div class="flex items-center justify-between w-full flex-wrap gap-1">
                                <div class="flex-1 min-w-0">
                                    <p class="text-xs font-semibold"
                                       style="color: #FF9735;">⚠️ Archivo no será procesado</p>
                                    <p class="text-[10px]"
                                       style="color: rgba(255,151,53,0.65);">Solo se aceptan mensajes de texto</p>
                                    <p class="text-[10px] truncate"
                                       style="color: rgba(255,151,53,0.45);">
                                        {{ selectedFile.name.length > 20
                                            ? (selectedFile.name | slice:0:20) + '…'
                                            : selectedFile.name }}
                                    </p>
                                </div>
                                <button type="button" (click)="clearFile()"
                                    class="flex-shrink-0 inline-flex items-center justify-center
                                           focus:outline-none transition-colors duration-200"
                                    style="color: #FF9735;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                         viewBox="0 0 24 24" fill="none">
                                        <path fill="none" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="1.5"
                                            d="M14 11v6m-4-6v6M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7M4 7h16M7 7l2-4h6l2 4" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- ── FILA DE CONTROLES ── -->
                        <div class="relative flex items-center gap-1.5 sm:gap-2 overflow-hidden"
                            style="height: 38px; min-height: 38px; max-height: 38px;">

                            <!-- BOTÓN AUDIO (desactivado — comentado) -->
                            <!-- <button type="button" (click)="toggleSpeak()" ...> -->

                            <!-- BOTÓN MICRÓFONO (desactivado — comentado) -->
                            <!-- <button type="button" (click)="toggleRecording()" ...> -->

                            <!-- BOTÓN CANCELAR GRABACIÓN (desactivado — comentado) -->
                            <!-- <button *ngIf="isRecording" type="button" (click)="cancelRecording()" ...> -->

                            <!-- ZONA DE TEXTO / INDICADOR DE GRABACIÓN -->
                            <div class="flex-1 relative overflow-hidden" style="height: 38px;">

                                <!-- Indicador grabando -->
                                <div *ngIf="isRecording"
                                    class="absolute inset-0 flex items-center justify-center rounded-lg px-3"
                                    style="background: rgba(255,151,53,0.07);
                                           border: 1px solid rgba(255,151,53,0.4);">
                                    <div class="flex items-center gap-2 whitespace-nowrap">
                                        <span class="rounded-full flex-shrink-0 animate-pulse w-2 h-2"
                                              style="background: #FF9735;"></span>
                                        <span class="font-semibold text-xs sm:text-sm flex-shrink-0"
                                              style="color: #FF9735;">
                                            REC {{ recordingTime }}s
                                        </span>
                                        <span class="hidden sm:inline text-[10px] flex-shrink-0"
                                              style="color: rgba(255,151,53,0.55);">
                                            &middot; toca para detener
                                        </span>
                                    </div>
                                </div>

                                <!-- Textarea de escritura -->
                                <textarea *ngIf="!isRecording" #messageInput
                                    placeholder="Consulta sobre tasa de seguridad..."
                                    [(ngModel)]="newMessageUser"
                                    name="message"
                                    (keypress)="handleKeyPress($event)"
                                    class="block w-full h-full text-sm rounded-lg px-3 py-2 resize-none
                                           transition-all duration-200 chat-input"
                                    rows="1"
                                    [maxlength]="MAX_MESSAGE_LENGTH"
                                    style="overflow-x: hidden; overflow-y: auto; line-height: 1.5;">
                                </textarea>
                            </div>

                            <!-- BOTÓN ENVIAR -->
                            <button type="submit"
                                [disabled]="!canSendMessage() || isRecording || newMessageUser.trim() === ''"
                                class="inline-flex items-center justify-center rounded-lg h-8 w-8
                                       transition-all duration-200 flex-shrink-0"
                                [ngStyle]="{
                                    'background': (canSendMessage() && !isRecording && newMessageUser.trim() !== '')
                                        ? '#1C3762' : 'rgba(28,55,98,0.06)',
                                    'border': (canSendMessage() && !isRecording && newMessageUser.trim() !== '')
                                        ? '1px solid #1C3762' : '1px solid #E4E4E4',
                                    'color': (canSendMessage() && !isRecording && newMessageUser.trim() !== '')
                                        ? '#ffffff' : 'rgba(28,55,98,0.25)',
                                    'cursor': (!canSendMessage() || isRecording || newMessageUser.trim() === '')
                                        ? 'not-allowed' : 'pointer'
                                }"
                                (click)="sendMessage()">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24">
                                    <path fill="currentColor"
                                        d="m6.998 10.247l.435.76c.277.485.415.727.415.993s-.138.508-.415.992l-.435.761c-1.238 2.167-1.857 3.25-1.375 3.788c.483.537 1.627.037 3.913-.963l6.276-2.746c1.795-.785 2.693-1.178 2.693-1.832s-.898-1.047-2.693-1.832L9.536 7.422c-2.286-1-3.43-1.5-3.913-.963s.137 1.62 1.375 3.788" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <!-- /ÁREA DE INPUT -->

                </div>
            </div>
            <!-- /COLUMNA PRINCIPAL -->

        </div>
    </div>
</div>
